import React from 'react';

interface ChevronRightIconProps {
  size?: number;
}

const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({ size = 12 }) => (
  <svg width={size} viewBox="0 0 9 18" fill="none">
    <path d="M 0 0 L 6 9 L 0 18" stroke="black" />
  </svg>
);

export default ChevronRightIcon;
